<template>
  <div class="contents">
    <div
      v-if="error"
      class="bg-surface-canvas dark:bg-surface-level-900 flex items-center justify-center"
    >
      <AppErrorState
        :icon="errorIcon"
        :title="errorTitle"
        :message="errorMessage"
        :error-code="errorCode"
        :primary-action="primaryAction"
        :secondary-action="secondaryAction"
      />
    </div>

    <slot v-else />
  </div>
</template>

<script setup lang="ts">
import { Lock } from '@lucide/vue'
import { computed } from 'vue'
import AppErrorState from '~/components/shared/AppErrorState.vue'
import { useErrorStore } from '~/stores/useErrorStore'

const errorStore = useErrorStore()

defineSlots<{
  default?: () => unknown
}>()

const error = computed(() => errorStore.hasError)
const errorIcon = computed(() => errorStore.icon || Lock)
const errorTitle = computed(() => errorStore.title)
const errorMessage = computed(() => errorStore.message())
const primaryAction = computed(() => errorStore.primaryAction)
const secondaryAction = computed(() => errorStore.secondaryAction)

const errorCode = computed(() => {
  switch (errorStore.type) {
    case '401':
      return '401'
    case '403':
      return '403'
    case '404':
      return '404'
    default:
      return ''
  }
})
</script>
